import React, {useEffect, useContext, useState} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLScriptComponent } from 'ml-components-common-react';
import { UserService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import PATrackEvent from '../../components/TrackEvent/PATrackEvent';
import metadata from './BindingScriptsPage.metadata.json5';
import messages from './BindingScriptsPage.messages';
import HOTrackEvent from '../../components/TrackEvent/HOTrackEvent';
import PUMBTrackEvent from '../../components/TrackEvent/PUMBTrackEvent';

const BindingScriptsPage = (props) => {
    const { wizardData: submissionVM, goNext } = props;
    const isGPA = appConfig.portalCode === 'GPA';
    const { authHeader } = useAuthentication();
    const [isChecked, setIsChecked] = useState(false);
    const [showAutopayCheckbox, setShowAutopayCheckbox] = useState(false);
    const [showDownpaymentCheckbox, setShowDownpaymentCheckbox] = useState(false);
    const translator = useTranslator();

    const updateCheckboxValue = (value) => {
        setIsChecked(value);
    };

    const showCheckbox = () => {
        return showAutopayCheckbox || showDownpaymentCheckbox;
    };

    const getCheckboxLabel = () => {
        if (showDownpaymentCheckbox) {
            return translator(messages.genericScriptsCheckbox);
        }
        return translator(messages.autopayScriptsCheckbox);
    };

    useEffect(() => {
        setTimeout(()=>{
            const element = document.getElementById("mlScriptComponentContainer");
            if(element){
                element.focus();
            }
        }, 100)
  }, []);

    useEffect(() => {
        if (isGPA) {
            const scriptArray = _.get(submissionVM, 'script_ML.value', []);
            setShowAutopayCheckbox(scriptArray.some((script) => script.indexOf('autopayScriptCheckbox') > -1));
            setShowDownpaymentCheckbox(scriptArray.some((script) => script.indexOf('downpaymentScriptCheckbox') > -1));

            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Binding Script Page' });
                }
                else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Binding Script Page' });
                }
                else {
                    PATrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Binding Script Page'});
                }
            });
        }
    }, [authHeader, isGPA, submissionVM]);

    const onNext = () => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Binding Script Page', action: 'Binding Script Submitted' });
                }
                else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Binding Script Page', action: 'Binding Script Submitted' });
                }
                else {
                    PATrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Binding Script Page', action: 'Binding Script Submitted' });
                }
            });
        }
        goNext();
    };

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.nextText}
                values={{
                    addlInfo: (
                        <strong>{translator(messages.additionalInformation)}</strong>
                    )
                }}
            />
        );
    };

    const overrideProps = {
        mlScriptComponent: {
            mlScript: _.get(submissionVM, 'script_ML.value', [])
        },
        nextDescription: {
            content: getNextStepText()
        },
        nextButton: {
            disabled: showCheckbox() && !isChecked
        },
        scriptCheckboxField: {
            value: isChecked,
            visible: showCheckbox(),
            onValueChange: updateCheckboxValue,
            label: getCheckboxLabel()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext
        },
        resolveComponentMap: {
            mlScriptComponent: MLScriptComponent
        }
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            showNext={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
};

BindingScriptsPage.propTypes = wizardProps;
export default BindingScriptsPage;
